import React from 'react';
import { useTranslation } from 'react-i18next';

import OnboardingButton from '../OnboardingButton';
import { OnboardingFormCard } from '../OnboardingFormCard';
import { OnboardingFormCardTitle } from '../OnboardingFormCardTitle';

interface OnboardingWorkspaceLoadErrorProps {
  apiHostname?: string;
  onRetry: () => void;
}

export const OnboardingWorkspaceLoadError: React.FC<
  OnboardingWorkspaceLoadErrorProps
> = ({ apiHostname, onRetry }) => {
  const { t } = useTranslation();
  const subTitle = apiHostname
    ? t(
        ($) => $.page_onboarding.login.workspaceLoadError.subtitleWithHostname,
        { apiHostname },
      )
    : t(($) => $.page_onboarding.login.workspaceLoadError.subtitle);

  return (
    <OnboardingFormCard>
      <OnboardingFormCardTitle
        title={t(($) => $.page_onboarding.login.workspaceLoadError.title)}
        subTitle={subTitle}
      />
      <OnboardingButton
        htmlId="retry-workspace-load"
        variant="contained"
        onClick={onRetry}
      >
        {t(($) => $.page_onboarding.login.workspaceLoadError.retry)}
      </OnboardingButton>
    </OnboardingFormCard>
  );
};
